// =====================================
//
//   付款結果 Controller
//   Author: Gray
//   createtime: 2016 / 09 / 20
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentOutwardRemittanceController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService) {

        var getExtraFee = function() {

            $scope.isLoading = true;
            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                $scope.isLoading = false;

                if(result) {
                    $scope.extrafee = result;
                    $scope.orderid = $scope.extrafee.orderid;
                    
                    if($scope.extrafee.status != 300) {
                        $state.go(window.STATES.ORDER, {orderid: $scope.orderid});
                        $scope.isLoading = true;
                    }
                } else {
                    $scope.isError = true;
                }

            }, function(error) {
                if(error && error.code == 'error.itemIsNotExist') {
                    $scope.isExtrafeeNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.extrafee || $scope.isPaying) {
                return;
            }

            var extrafeeid = $scope.extrafeeid,
                remittanceName = undefined,
                remittanceCode = undefined,
                remittancePhone = undefined,
                remittanceDate = !$scope.form.hasCode ? $scope.form.remittanceDate : undefined;


            if($scope.form.hasCode) {
                remittanceCode = $scope.form.remittanceCode;
            } else {
                remittanceName = $scope.form.remittanceName;
                remittancePhone = $scope.form.remittancePhone;

                var dates = $scope.form.remittanceDate.split("/");
                var times = $scope.form.remittanceTime.split(":");

                remittanceDate = dates[0] + dates[1] + dates[2] + times[0] + times[1];
            }

            $scope.isPaying = true;

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '處理中',
            });

            ExtraFeeService.payExtraFeeWithOutwardRemittance(extrafeeid, remittanceName, remittanceCode, remittancePhone, remittanceDate).then(function(result) {
                if(result) {
                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '完成通知付款',
                    });

                    $state.go(window.STATES.ORDER, {orderid: $scope.orderid});
                } else {
                    $scope.isError = true;
                    $scope.isPaying = false;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }             
            }, function(error) {

                $scope.isError = true;
                $scope.isPaying = false;
                $scope.isPayError = false;

                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                    title: '系統發生錯誤',
                });
            });
        };

        var confirmPay = function(){

            if(!canConfirmPay()) {
                $scope.isRemittanceInfoError = true;
                return;
            }

            $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                title: '確定通知付款',
                description: '請確認款項已成功匯出，並填寫正確匯款資訊？',
                callback: function(result) {
                    if(result) {
                        pay();
                    }
                }
            })
        }

        var canConfirmPay = function() {

            if($scope.form.hasCode) {
                return $scope.form.remittanceCode && $scope.form.remittanceCode.length == 5;
            } else {
                return $scope.form.remittanceName && $scope.form.remittancePhone && $scope.form.remittanceDate;
            }
        }

        var editRemittanceInfo = function() {

            $rootScope.$broadcast('OPEN_EDIT_REMITTANCE_INFO_MODAL', {
                remittanceName: $scope.form.remittanceName,
                remittanceCode: $scope.form.remittanceCode,
                remittancePhone: $scope.form.remittancePhone,
                remittanceDate: $scope.form.remittanceDate,
                remittanceTime: $scope.form.remittanceTime,
                hasCode: $scope.form.hasCode,
                callback: function(data) {
                    $scope.form.remittanceName = data.remittanceName;
                    $scope.form.remittanceCode = data.remittanceCode;
                    $scope.form.remittancePhone = data.remittancePhone;
                    $scope.form.remittanceDate = data.remittanceDate;
                    $scope.form.remittanceTime = data.remittanceTime;
                    $scope.form.hasCode = data.hasCode;
                    $scope.hasInfo = true;
                    $scope.isRemittanceInfoError = false;
                }
            })
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;
                getExtraFee();
            }, function(error) {
                $scope.isLogin = false;

                $state.go(window.STATES.HOME);
            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
            init();
        });

        $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {

        });

        //==========================
        //  Members
        //==========================
        $scope.form = {
            remittanceName: '',
            remittanceCode: '',
            remittancePhone: '',
            remittanceDate: '',
            remittanceTime: '',
            hasCode: true,
        }
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.orderid = $stateParams.orderid;
        $scope.extrafee;
        $scope.isError = false;
        $scope.isLoading = false;
        $scope.isComplete = false;
        $scope.isExtrafeeNotExist = false;
        $scope.isOverError = false;
        $scope.isPayError = false;
        $scope.isSelected = true;
        

        //==========================
        //  Methods
        //==========================
        $scope.confirmPay = confirmPay;
        $scope.editRemittanceInfo = editRemittanceInfo;

        //==========================
        //  Init
        //==========================
        init();
	}
]);